import { graphql, useStaticQuery } from "gatsby"
import { Helmet } from "gatsby-plugin-react-i18next"
import * as React from "react"
import PropTypes from "prop-types"

interface IProps {
  description?: string,
  lang?: string,
  image?: {
    src: string,
    height: number,
    width: number,
  },
  title: string,
  pathname?: string,
}

const SEO = ({ description, lang, image: metaImage, title, pathname }: IProps) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )
  const metaDescription = description || site.siteMetadata.description
  const image =
    metaImage && metaImage.src
      ? `${site.siteMetadata.siteUrl}${metaImage.src}`
      : null
  const canonical = pathname ? `${site.siteMetadata.siteUrl}${pathname}` : null
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      link={
        canonical
          ? [
              {
                rel: "canonical",
                href: canonical,
              },
            ]
          : []
      }
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ]
        .concat(
          metaImage
            ? [
                {
                  property: "og:image",
                  content: image,
                },
                {
                  property: "og:image:width",
                  content: metaImage.width,
                },
                {
                  property: "og:image:height",
                  content: metaImage.height,
                },
                {
                  name: "twitter:card",
                  content: "summary_large_image",
                },
              ]
            : [
                {
                  name: "twitter:card",
                  content: "summary",
                },
              ]
        )}
    >
      <link rel="alternate" href={`${site.siteMetadata.siteUrl}${pathname}`} hrefLang="en-in" />
      <link rel="alternate" href={`${site.siteMetadata.siteUrl}/uz${pathname}`} hrefLang="uz-uz" />
      <link rel="alternate" href={`${site.siteMetadata.siteUrl}/ru${pathname}`} hrefLang="ru-uz" />
    </Helmet>
  )
}
SEO.defaultProps = {
  lang: `en`,
  description: ``,
}
SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  pathname: PropTypes.string,
}

export default SEO